import React, { useState, useContext } from 'react';
import { loginUser } from '../../services/api';
import './Forms.css';
import routes from '../../utils/routes';
import { AuthContext } from '../../contexts/AuthContext';
import { showToast } from '../../utils/utils';
import logo from '../../assets/images/full_logo_color.svg';


function LoginForm() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await loginUser(username, password);
      login(data.token, data.user);
      showToast('success', 'Logueado Correctamente!');
      window.location = routes.home;
    } catch (error) {
      if (error.response && error.response.data) {
        setError('Credenciales inválidas, intente nuevamente.');
      } else {
        showToast('error', 'Error ingresando');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    if (error) {
      setError('');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="form-complete">
      <img src={logo} alt="logo-text" />
      <form onSubmit={handleSubmit}>
        <div className="form-fields">
          <input
            type="username"
            placeholder="Usuario"
            name="username"
            value={username}
            onChange={handleInputChange(setUsername)}
            required
          />
          <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              name="password"
              value={password}
              onChange={handleInputChange(setPassword)}
              required
            />
            <span className="material-symbols-outlined password-icon" onClick={togglePasswordVisibility}>
              {showPassword ? "visibility_off" : "visibility"}
            </span>
          </div>
          {error && <p className="error-message">{error}</p>}
          <button className="common-button" type="submit" disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default LoginForm;
